import React, { useEffect, useState } from 'react';
import { Typography, Breadcrumb, Card, Form, Switch, Input, Button, Space, message } from 'antd';
import api from '../../../utils/api';

const { Title, Paragraph } = Typography;

const GDPRPrivacy = () => {
  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    let alive = true;
    async function load() {
      try {
        setLoading(true);
        const data = await api.get('/settings/gdpr-privacy');
        if (alive) {
          form.setFieldsValue({
            data_export_enabled: !!data?.data_export_enabled,
            data_deletion_enabled: !!data?.data_deletion_enabled,
            analytics_tracking: !!data?.analytics_tracking,
            privacy_policy_url: data?.privacy_policy_url || '',
            data_retention_days: data?.data_retention_days ?? 365,
          });
        }
      } catch (e) {
        message.error(e.message || 'Failed to load GDPR/Privacy settings');
      } finally {
        if (alive) setLoading(false);
      }
    }
    load();
    return () => { alive = false; };
  }, [form]);

  const onSubmit = async () => {
    try {
      await form.validateFields();
      setSaving(true);
      const values = form.getFieldsValue();
      await api.put('/settings/gdpr-privacy', values);
      message.success('GDPR/Privacy settings saved');
    } catch (e) {
      if (e?.errorFields) return;
      message.error(e.message || 'Failed to save');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{ padding: 24 }}>
      <Breadcrumb items={[{ title: 'Admin' }, { title: 'Security' }, { title: 'GDPR / Privacy' }]} />

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 12, marginBottom: 16 }}>
        <Title level={3} style={{ margin: 0 }}>GDPR / Privacy Settings</Title>
        <Space>
          <Button type="primary" onClick={onSubmit} loading={saving || loading} disabled={loading}>Save Settings</Button>
        </Space>
      </div>

      <Card>
        <Paragraph type="secondary" style={{ marginBottom: 12 }}>Configure privacy options and data retention limits.</Paragraph>
        <Form form={form} layout="vertical" disabled={loading}>
          <Form.Item label="Enable User Data Export" name="data_export_enabled" valuePropName="checked">
            <Switch />
          </Form.Item>
          <Form.Item label="Enable User Data Deletion" name="data_deletion_enabled" valuePropName="checked">
            <Switch />
          </Form.Item>
          <Form.Item label="Enable Analytics Tracking" name="analytics_tracking" valuePropName="checked">
            <Switch />
          </Form.Item>
          <Form.Item label="Privacy Policy URL" name="privacy_policy_url" rules={[{ type: 'url', message: 'Enter a valid URL' }]}> 
            <Input placeholder="https://..." />
          </Form.Item>
          <Form.Item label="Data Retention (days)" name="data_retention_days" rules={[{ required: true }]}> 
            <Input type="number" min={0} />
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default GDPRPrivacy;

